export const daysBetween = (date) => {
  if (!date) return 9999;
  const now = new Date();
  const target = new Date(date);
  return Math.floor((now - target) / (1000 * 60 * 60 * 24));
};

export const sortAnswers = (answers, sortBy) => {
  let data = [...answers];

  switch (sortBy) {
    case "recent":
      return data
        .filter(a => daysBetween(a.created_at) <= 10)
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    case "popular": {
      if (data.length === 0) return [];

      const maxLikes = Math.max(...data.map(a => a.likes_count || 0));
      return data.filter(a => (a.likes_count || 0) === maxLikes);
    }

    default:
      return data;
  }
};